import React from 'react';
import { HStack, Text, SimpleTable } from '@doveit/bricks';
import { formatEuro } from '@doveit/hammer';
import { PropertyUnit } from '../../../providers/api/dtos';
import { energyClassLabels, propertyUnitIntendedUseLabels } from '../../../labels';
import UpsertPropertyUnitAction from '../upsert-property-unit-action/UpsertPropertyUnitAction';
import DeletePropertyUnitAction from '../delete-property-unit-action/DeletePropertyUnitAction';
import { NO_VALUE_SYMBOL } from '../../utils';

export interface ViewPropertyUnitTableRowProps {
  propertyUnit: PropertyUnit,
  canDelete?: boolean,
  canUpdate?: boolean,
  padded?: boolean,
  onUpdate?: (updatedPropertyUnit: PropertyUnit, oldPropertyUnit: PropertyUnit) => void,
  onDelete?: (deletedPropertyUnit: PropertyUnit) => void,

}

const ViewPropertyUnitTableRow: React.FC<ViewPropertyUnitTableRowProps> = ({
  propertyUnit,
  canDelete = false,
  canUpdate = false,
  padded = false,
  onUpdate,
  onDelete,
}) => (
  <SimpleTable.Row aria-label="Riga di una unità immobiliare" padded={padded}>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.section || NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.sheet || NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.parcel || NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.subunit || NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.category || NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.intendedUse ? propertyUnitIntendedUseLabels[propertyUnit.intendedUse] : NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.value ? formatEuro(propertyUnit.value) : NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    <SimpleTable.Cell>
      <Text.Body>
        {propertyUnit.energyClass ? energyClassLabels[propertyUnit.energyClass] : NO_VALUE_SYMBOL}
      </Text.Body>
    </SimpleTable.Cell>
    {(canUpdate || canDelete) && (
      <SimpleTable.Cell align="right">
        <HStack gap={75}>
          {canUpdate && (
            <UpsertPropertyUnitAction
              propertyUnit={propertyUnit}
              onSuccess={onUpdate}
            />
          )}
          {canDelete && (
            <DeletePropertyUnitAction
              propertyUnit={propertyUnit}
              onSuccess={onDelete}
            />
          )}
        </HStack>
      </SimpleTable.Cell>
    )}
  </SimpleTable.Row>
);

export default ViewPropertyUnitTableRow;
